import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getLocationListCSV = () => {
  const url = `${apiConstants?.BASE_URL_1}/api/v1/Location/GetStoreList`;
  const encodedUrl = encodeURIComponent(url);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ORGANIZATION_SETTINGS.GET_LOCATION_LIST_CSV(encodedUrl)
  );
};

export default getLocationListCSV;
